import fake from '../raws/get.json'

export default {
  postUrl() {
    return 'https://jsonplaceholder.typicode.com/posts'
  },
  format(payload) {
    console.log('🚀 ~ saveAchievementTask format ~ payload:', payload)
    return payload
  },
  parse(raw = {}, payload = { type: '' }) {
    raw = fake.postRes
    if (raw?.statusCode !== 201 && raw?.statusCode !== 200)
      return {
        statusCode: raw?.statusCode || 500,
        message: raw?.message || 'Le serveur semble innaccessible',
        data: raw?.data || null,
      }

    return {
      statusCode: 200,
      message: 'ok',
      data: {
        saved: true,
      },
    }
  },
}
